<template>
  <f7-page no-toolbar  no-swipeback name="invite-friends" class="page-messgae-center">
    <f7-navbar innerClass="navbar-inner-message">
      <f7-nav-left>
        <f7-link @click="$f7router.navigate('/home/')">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>{{ $t("invite_friends_0001") }}</f7-nav-title>
      <f7-nav-right>
        <f7-link></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="content">
      <div class="info">
        <div class="one">
          <div style="font-size: 12px;margin: 0;">{{ $t("invite_friends_0002") }}</div>
          <div>{{ numberCode }}</div>
        </div>
        <div class="two">
          <div class="er" id="qrcode"></div>
        </div>
      </div>

      <div class="inlink" >
        <div style="font-weight: bold;">{{ $t("invite_friends_0003") }}</div>
        <div style="font-size: 12px;">{{ link }}</div>
      </div>
      <div class="btn" >
        <div class="btncode" v-clipboard:copy="numberCode" v-clipboard:success="onCopy" v-clipboard:error="onError">{{ $t("invite_friends_0018") }}</div>
        <div class="btnlink" v-clipboard:copy="link" v-clipboard:success="onCopy" v-clipboard:error="onError">{{ $t("invite_friends_0019") }}</div>
      </div>

      <div class="allyi">
        <div style="margin-bottom: 5px;">{{ $t("invite_friends_0008") }}</div>
        <div style="font-size: 16px;font-weight: bold;"><span class="symbol">{{ currencySymbol }}</span>{{ totalProfitAmount | formatCurrency }}</div>
      </div>

      <div class="showinfo">
        <div class="left">
          <div>{{ $t("invite_friends_0006") }}</div>
          <div>{{ totalReferrerDownlineCount}}</div>
        </div>
        <div class="right">
          <div>{{ $t("invite_friends_0007") }}</div>
          <div><span class="symbol">{{ currencySymbol }}</span>{{ todayProfitAmount | formatCurrency}}</div>
        </div>
      </div>

      <div class="alltw">
        <div @click="$f7router.navigate('/member-center/invite-overview/')">
          <div><img src="../../../static/images/yt999/home/ico/ZZicon/Frame1.png" alt="" style="height: 28px;"></div>
          <div>{{ $t("invite_friends_0009") }}</div>
        </div>
        <div @click="$f7router.navigate('/member-center/friend-details/')">
          <div><img src="../../../static/images/yt999/home/ico/ZZicon/Frame2.png" alt=""  style="height: 28px;"></div>
          <div>{{ $t("invite_friends_0010") }}</div>
        </div>
        <div @click="goCommission()">
          <div><img src="../../../static/images/yt999/home/ico/ZZicon/Frame3.png" alt=""  style="height: 28px;"></div>
          <div>{{ $t("invite_friends_0011") }}</div>
        </div>
      </div>
      <div v-if="InviteFriendPageRemark" v-html="InviteFriendPageRemark"></div>
      <!-- <div class="wenzi">
        <h3 style="color: var(--f7-THEME-color)">{{ $t("invite_friends_0012") }}</h3>
        <p>1. {{ $t("invite_friends_0013") }}</p>
        <p>2. {{ $t("invite_friends_0014") }}</p>
        <p>3. {{ $t("invite_friends_0015") }}</p>
        <p>4. {{ $t("invite_friends_0016") }}</p>
        <p style="color: var(--f7-THEME-color)">5. {{ $t("invite_friends_0020") }}</p>
      </div> -->
    </div>
    <div class="code" id="addcode" style="display: none">
      <div class="er" id="qrcode"></div>
      <div class="un">
        <div class="num">
          <div style="text-align: center; width: 100%">{{ numberCode }}</div>
          <!-- <div class="coppya"><a href="#" v-clipboard:copy="link" v-clipboard:success="onCopy" v-clipboard:error="onError"></a></div> -->
        </div>
        <div style="text-align: left">{{ $t("invite_friends_0017") }}:</div>
        <div class="href">
          <div>
            {{ link }}
          </div>
        </div>
      </div>
    </div>
  </f7-page>
</template>

<script>
import QRCode from "qrcodejs2";
import { getCookie,getStore } from "@/config/utils";
import { referrerinfo,getwebsiteinfoGet } from "../../../axios/api";

export default {
  components: { QRCode },
  props: {},
  data() {
    return {
      currencySymbol: getStore('currencySymbol'),
      readActiveIndex: 0,
      link: " ",
      numberCode: 0,
      referrerinfoList: [],
      totalReferrerDownlineCount: 0, //好友人数
      todayProfitAmount: 0, //今日收益
      monthProfitAmount: 0, //月收益
      totalProfitAmount: 0, //总收益
      InviteFriendPageRemark: ''
    };
  },
  watch: {},
  computed: {},
  methods: {
    //  生成二维码
    qrcode() {
      let self = this;
      this.numberCode = getCookie("p");
      this.link = window.location.protocol + "//" + window.location.host + "/#/register/" + "?d=" + this.numberCode;
      let qrcode = new QRCode("qrcode", {
        width: 30,
        height: 30, // 高度
        text: this.link, // 二维码内容
        useSVG: true, // 使用 SVG 而非 Canvas
        correctLevel: QRCode.CorrectLevel.L, // 使用较低的纠错等级
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色
      });
    }, // 弹窗
    logout() {
      const self = this;
      self.$f7.$(".dialog-backdrop").css("background", "rgba(0, 4, 7, 0.77)");
      self.$f7.dialog
        .create({
          title: this.$t(""),
          text: document.getElementById("addcode").innerHTML,
          cssClass: "code",
          buttons: [],
        })
        .open();
    },
    getreferrerinfo() {
      const self = this;
      referrerinfo().then((data) => {
        if (data.Code === "NoError") {
          self.referrerinfoList = data.Data;
          self.totalReferrerDownlineCount = data.Data["TotalReferrerDownlineCount_L1"] + data.Data["TotalReferrerDownlineCount_L2"] + data.Data["TotalReferrerDownlineCount_L3"];
          self.todayProfitAmount = data.Data["TodayProfitAmount"];
          self.totalProfitAmount = data.Data["TotalProfitAmount"];
          self.monthProfitAmount = data.Data["MonthProfitAmount"];
        }
      });
    },
    goCommission() {
      const queryParam = { TodayProfitAmount: this.todayProfitAmount, TotalProfitAmount: this.totalProfitAmount, MonthProfitAmount: this.monthProfitAmount };
      this.$f7router.navigate(`/member-center/commission-details/${JSON.stringify(queryParam)}/`);
    },
    backMemberCenter() {
      this.$f7router.back();
    },
    openMsgPopup() {
      this.showMsgPopup = true;
    },
    closeMsgPopup() {
      this.popupMsgOpened = false;
      this.showMsgPopup = false;
    },
    onCopy(e) {
      const self = this;
      if (e.text) {
        let copyLoading = self.$f7.dialog
          .create({
            title: "",
            text: this.$t("common_0003"),
            cssClass: "dialog-preloadgame",
          })
          .open();

        setTimeout(() => {
          copyLoading.close();
        }, 1000);
      }
    },
    onError(e) {
      console.log(e);
    },
    getwebsiteinfoGet(){
      getwebsiteinfoGet().then((data) => {
        if (data.Code === "NoError") {
          this.InviteFriendPageRemark= data.Data.InviteFriendPageRemark;
        
        }
      });
    }
  },
  created() {
    this.getreferrerinfo();
    this.getwebsiteinfoGet();
    this.$f7.emit("myCustomEvent", "invite-friends");
  },
  mounted() {
    this.qrcode();
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 90%;
  margin: 10px auto;

  .info {
    display: flex;
    background: var(--f7-THEME-color);
    border-radius: 7px;
    color: white;
    div {
      div {
        width: 90%;
        text-align: center;
      }
    }

    .two:before {
      content: "";
      position: absolute;
      top: 23%;
      left: 8px;
      transform: translateX(-50%);
      width: 1px;
      height: 60%;
      background-color: var(--f7-THEME-color2);
    }

    .two:after {
      content: "";
      position: absolute;
      top: 23%;
      right: 8px;
      transform: translateX(-50%);
      width: 1px;
      height: 60%;
      background-color: var(--f7-THEME-color2);
    }

    .one {
      width: 75%;
      padding-top: 10%;
      div {
        height: 20px;
        line-height: 20px;
        margin-top: 6px;
      }

      div:nth-child(2) {
        font-size: 20px;
      }

      .coppy {
        background: #fff;
        color: #000;
        width: 70px;
        border-radius: 10px;
        margin: 7px auto;
        display: grid;
        align-content: center;
      }
    }
    .two{
      width: 25%;
      padding: 15px;
      .er{
        background: white;
        padding: 5px;
        font-size: 0;
      }
    }
  }
  .inlink{
    padding: 15px;
    background: #fff7ee;
    margin: 10px 0;
    border-radius: 7px;
  }
  .btn{
    text-align: center;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    color: white;
    .btncode{
      height: 30px;
      line-height: 30px;
      border-radius: 5px;
      background: #c1a96f;
    }
    .btnlink{

      height: 30px;
      line-height: 30px;
      border-radius: 5px;
      background: var(--f7-THEME-color);
    
    }
  }
  .showinfo{
      display: grid;
      grid-template-columns: 1fr 1fr; /* 每个子元素占据1/3的宽度 */
      grid-gap: 10px;
      text-align: center;
      .left{
        border-radius: 5px;
        padding: 15px 0px;
        background: #e9f7e9;
        div:nth-child(1){
          font-size: 12px;
        }
        div:nth-child(2){
          font-size: 15px;
          font-weight: bold;
        }
      }
      .right{
        border-radius: 5px;
        padding: 15px 0px;
        background: #fff7ee;
        div:nth-child(1){
          font-size: 12px;
        }
        div:nth-child(2){
          font-size: 15px;
          font-weight: bold;
        }
      }


    }
    .allyi{
      margin: 10px 0;
      border: 1px solid #e8e8e8;
      padding: 15px 10px;
      border-radius: 5px;
      background: #f1feff;
    }
    .alltw{
      margin: 10px 0;
      border: 1px solid #e8e8e8;
      padding: 10px;
      border-radius: 5px;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      text-align: center;
      font-size: 12px;
    }


  .num {
    display: grid;
    grid-template-columns: auto auto auto;
    border: 1px solid #f2f3f5;
    border-radius: 10px;
    margin: 15px 0;
    height: 76px;
    box-shadow: 0px 1px 4px rgb(185 182 152);

    div {
      div {
        width: 100%;
        text-align: center;
        height: 38px;
        line-height: 38px;
        font-size: 12px;
      }
    }

    div:nth-child(2):before {
      content: "";
      position: absolute;
      top: 10px;
      left: 0;
      transform: translateX(-50%);
      width: 1px;
      height: 55px;
      background-color: #f3f3f3;
    }

    div:nth-child(2):after {
      content: "";
      position: absolute;
      top: 10px;
      right: 0;
      transform: translateX(-50%);
      width: 1px;
      height: 55px;
      background-color: #f3f3f3;
    }
  }

  .hen {
    background: var(--f7-THEME-color2);
    border: 1px solid var(--f7-THEME-color);
    border-radius: 10px;
    height: 40px;
    line-height: 40px;
    padding: 0 0 0 20px;
    position: relative;
    margin: 0 0 10px 0;

    .rig {
      position: absolute;
      top: 13px;
      right: 20px;
      font-size: 16px;
    }
  }
}
// 邀请二维码
.code {
  width: 370px;
  height: 425px;
  background: #fff;
  border-radius: 5px;
  .er {
    width: 200px;
    height: 200px;
    padding: 20px;
    border-bottom: 1px dashed #8f8f8f;
    display: grid;
    justify-content: center;
    align-content: center;
    position: relative;
  }
  .er::before {
    content: "";
    position: absolute;
    left: -26px;
    bottom: -10px;
    border-radius: 20px;
    height: 20px;
    width: 20px;
    background: #514d4d;
    box-sizing: border-box;
  }
  .er::after {
    content: "";
    position: absolute;
    right: -26px;
    bottom: -10px;
    border-radius: 20px;
    height: 20px;
    width: 20px;
    background: #514d4d;
    box-sizing: border-box;
  }
  .un {
    margin: 0 auto;
    .num {
      display: flex;
      background: var(--f7-THEME-color);
      border-radius: 5px;
      color: white;
      height: 35px;
      line-height: 35px;
      padding: 0 15px;
      margin: 20px 0px;
      div:nth-child(1) {
        width: 50%;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
      }
      div:nth-child(2) {
        width: 50%;
        text-align: right;
        a {
          color: white;
        }
      }
    }
    .href {
      background: var(--f7-THEME-color2);
      border: 1px solid var(--f7-THEME-color);
      border-radius: 5px;
      padding: 10px;
      min-height: 30px;
      color: #514d4d;
      overflow-wrap: break-word; //文字溢出换行
    }
  }
  #qrcode {
    img {
      margin: 0px auto;
      padding: 50px 0;
      height: 150px;
    }
  }
}
</style>
